import React from 'react'
import { connect } from 'react-redux'

import { ORDER_MODAL_ACTION_TEXT, SUCCESS } from '../../../../../helpers'
import { ReactModal } from '../../../../../components'
import { MEETING, MODAL, ORDER } from '../../../../../reduxs'

import { SuccessOrderModalStyle } from './styles'

function SuccessOrderModal(props) {
  const {
    language,
    orderActionText,
    isOpenSuccessOrderModal,
    closeSuccessOrderModal,
    clearOrderActionText,
    colorTheme,
    getBookingDetailById,
    bookingId,
    setIsEditOrder,
  } = props

  const handleClickDone = () => {
    closeSuccessOrderModal()
    clearOrderActionText()
    setIsEditOrder(false)

    getBookingDetailById({ bookingId })
  }

  return (
    <ReactModal isVisible={isOpenSuccessOrderModal} width={440} borderRadius={8} >
      <SuccessOrderModalStyle colorTheme={colorTheme} >
        <h2 className='success-order-modal__title'>{SUCCESS[language]}</h2>
        <p className='success-order-modal__text'>
          {orderActionText && orderActionText[language]}
        </p>
        <button
          className='success-order-modal__button--done'
          onClick={handleClickDone}
        >
          {ORDER_MODAL_ACTION_TEXT.DONE[language]}
        </button>
      </SuccessOrderModalStyle>
    </ReactModal>
  )
}

const mapStateToProps = ({ orderReducer, accountReducer, modalReducer, meetingReducer }) => {
  return {
    confirmItems: orderReducer.confirmItems,
    colorTheme: accountReducer.user.colorThemePalette,
    isOpenSuccessOrderModal: modalReducer.orderModal.isOpenSuccessOrderModal,
    orderActionText: orderReducer.orderActionText,
    bookingId: meetingReducer.bookingDetail.bookingId,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeSuccessOrderModal: () => dispatch(MODAL.action.setSuccessOrderModal(false)),
    clearOrderActionText: () => dispatch(ORDER.action.clearOrderActionText()),
    getBookingDetailById: (params) => dispatch(MEETING.action.getBookingDetailById(params)),
    setIsEditOrder: (isEditOrder) => dispatch(ORDER.action.setIsEditOrder(isEditOrder)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SuccessOrderModal)